/**
 * Landing / subscribe flows writing to Firestore `subscribers`.
 * Keep discount strings in sync with `onSubscriberCreate` in functions/src/index.ts (welcome email HTML).
 */
export const LANDING_SUBSCRIBERS_COLLECTION = 'subscribers' as const;
export const LANDING_SUBSCRIBER_DISCOUNT_CODE = 'WELCOME20' as const;
export const LANDING_SUBSCRIBER_DISCOUNT_PERCENT = 20 as const;
